import { Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import {DataService} from "../../../services/data.service";
import {ToastrService} from "ngx-toastr";
import {LocalStorageService} from "../../../services/local-storage.service";
import {AccessService} from "../../../services/access.service";
import {RouterLink} from "@angular/router";
import {NgForOf, NgIf} from "@angular/common";
import {PaginationComponent} from "ngx-bootstrap/pagination";
import {FormsModule} from "@angular/forms";
import {DebounceKeyupDirective} from "../../../directives/debounce-keyup.directive";

@Component({
    selector: 'app-customer-list',
    templateUrl: './customer-list.component.html',
    imports: [
        RouterLink,
        NgForOf,
        NgIf,
        PaginationComponent,
        FormsModule,
        DebounceKeyupDirective
    ],
    styleUrl: './customer-list.component.scss'
})
export class CustomerListComponent implements OnInit {

    accessService = inject(AccessService);
    private dataService = inject(DataService);
    private toastrService = inject(ToastrService);
    private localStorageService = inject(LocalStorageService);

    @ViewChild('inputFile') inputFile: ElementRef;

    paginConfig;
    entries;
    totalEntries;
    predicate;
    search;
    reverse;
    csvFile: any = null;
    importing = false;

    ngOnInit(): void {
        this.search = {
            number: '',
            lastname: '',
            firstname: '',
            zip: '',
            city: '',
            street: '',
            phone: '',
        };

        let searchSaved = this.localStorageService.getItem('customer-list');
        if (searchSaved) {
            this.search = {...this.search, ...searchSaved}
        }

        this.paginConfig = {
            itemsPerPage: 25,
            page: 1
        };
        this.reverse = false;
        this.totalEntries = 0;
        this.predicate = 'lastname';
        this.listEntries(this.paginConfig);
    }

    setOrder(order): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.localStorageService.setItem('customer-list', this.search);

        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('Customer/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            search: this.search,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.customers;
        });
    }

    handleInputChange(e): void {
        this.importing = true;

        for (let i = 0; i < e.target.files.length; i++) {
            let reader = new FileReader();
            reader.onload = (progressEvent) => {
                this.csvFile = {
                    name: e.target.files[i].name,
                    size: e.target.files[i].size,
                    type: e.target.files[i].type,
                    data: progressEvent.target.result
                };
                this.dataService.request('Customer/import', {
                    csv: this.csvFile.data
                }).subscribe(response => {
                    this.csvFile = '';
                    this.importing = false;
                    this.toastrService.success('Der Import wurde durchgeführt');
                    this.checkFilterAndList();
                });

            };
            reader.readAsDataURL(e.target.files[i]);
        }
    }

    triggerFileInput(): void {
        this.inputFile.nativeElement.click();
    };

}
